import { render, staticRenderFns } from "./fangDetail.vue?vue&type=template&id=6edff774&scoped=true"
import script from "./fangDetail.vue?vue&type=script&lang=js"
export * from "./fangDetail.vue?vue&type=script&lang=js"
import style0 from "./fangDetail.vue?vue&type=style&index=0&id=6edff774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edff774",
  null
  
)

export default component.exports